import React from "react";
import styled from "styled-components";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { deleteMatchFilterApi } from "api";
import { useMatchFilterContext } from "contexts";
// import { Link } from "@reach/router";
import { format } from "date-fns";
import { CreateMatchFilterModal } from "modals";
import { useModal } from "hooks";

export const TableRow = ({ isLoading, data }) => {
  const { deleteById } = useMatchFilterContext();
  const editModal = useModal();
  const handleEdit = async () => {
    editModal.openModal();
  };
  const handleDelete = async () => {
    await deleteMatchFilterApi(data?.match_filter_id);
    deleteById(data?.match_filter_id);
  };

  return isLoading ? (
    <SkeletonTheme color="#202020" highlightColor="#444">
      <Container isLoading>
        <div className="inner">
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
          <RowItem>
            <Skeleton height={32} />
          </RowItem>
        </div>
      </Container>
    </SkeletonTheme>
  ) : (
    // <Link to={`/schedulers/${data?.schedule_id}`}>
    <Container status={data?.status}>
      <div className="inner">
        {/* <RowItem></RowItem> */}
        <RowItem>{data?.name}</RowItem>
        <RowItem>{data?.status}</RowItem>
        <RowItem>{data?.retailer_name}</RowItem>
        <RowItem>{data?.url_path}</RowItem>
        <RowItem>{data?.description}</RowItem>
        <RowItem>{data?.scrape_type_name}</RowItem>
        <RowItem className="d-flex">
          <span>
            {data?.creation_time
              ? format(new Date(data?.creation_time), "MM/dd/yyyy")
              : ""}
          </span>
          <div className="ml-auto cursor-pointer" onClick={handleEdit}>
            <FaEdit />
          </div>
          <div className="ml-4 cursor-pointer mr-2" onClick={handleDelete}>
            <FaTrashAlt />
          </div>
        </RowItem>
      </div>
      {data?.status === "Errored" && (
        <Error>
          Error: Tasks failed, please review task errors <a href="/#">here</a>.
        </Error>
      )}
      <CreateMatchFilterModal {...editModal} data={data} />
    </Container>
    // </Link>
  );
};

const Container = styled.div`
  background: ${(props) => props.theme.palette.items};
  display: block;
  color: white;
  transition: all 300ms ease;
  font-size: ${(props) => props.theme.palette.m};
  border: 1px solid ${(props) => props.theme.palette.gray};
  border-left: 12px solid
    ${(props) =>
      props.status === "ACTIVE"
        ? props.theme.palette.success
        : props.theme.palette.secondary};

  margin: 3px 6px 3px 12px;
  border-radius: 2px;
  .inner {
    display: flex;
    width: 100%;
    padding: 0 0px 0 32px;
    height: 66px;
    &:hover {
      background: ${(props) =>
        props.isLoading
          ? props.theme.palette.items
          : props.theme.palette.itemsHover};
    }

    & > div:nth-child(1) {
      width: 120px;
    }
    & > div:nth-child(2) {
      width: 80px;
    }
    & > div:nth-child(3) {
      width: 120px;
    }
    & > div:nth-child(4) {
      width: 300px;
    }
    & > div:nth-child(5) {
      flex: 1;
    }
    & > div:nth-child(6) {
      width: 120px;
    }
    & > div:nth-child(7) {
      width: 200px;
    }
  }
`;

const RowItem = styled.div`
  margin: auto 16px auto 0;
`;

const Error = styled.div`
  height: 40px;
  line-height: 40px;
  background: ${(props) => props.theme.palette.error};
  color: white;
  font-size: ${(props) => props.theme.font.size.m};
  padding-left: 40px;
  a {
    color: white;
    text-decoration: underline;
  }
`;
